<template>
    <v-popup :modelValue="modelValue" title="Подтверждение почты" @close="$emit('update:modelValue', false)">
        <div class="email-input" v-if="!codeSending">
            <p>Указанная почта не подтверждена. Подтвердите почту для продолжения работы.</p>
            <v-input :inputs="emailInput"></v-input>
        </div>
        <div class="code-input" v-else>
            <p>Код отправлен на почту</p>
            <v-input :inputs="codeInput"></v-input>
        </div>
        <span class="error">{{ error }}</span>
        <template #footer v-if="!codeSending">
            <default-button @click="$emit('update:modelValue', false)" isSecondary text="Позже"></default-button>
            <default-button @click="sendVerificationCode" text="Отправить код"></default-button>
        </template>
        <template #footer v-else>
            <default-button @click="$emit('update:modelValue', false)" isSecondary text="Отмена"></default-button>
            <default-button @click="submitVerificationCode" text="Подтвердить"></default-button>
        </template>
    </v-popup>
</template>

<script>
import VPopup from '@/components/ui/VPopup.vue'
import inputUtils from '@/utils/inputUtils'
import { useUserStore } from '@/store/UserStore.js'

export default {
    name: 'VerifyEmailPopup',
    components: {
        VPopup
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            userStore: useUserStore(),
            codeSending: false,
            codeInput: [
                { id: 'code', placeholder: 'Код подтверждения', type: 'text', value: '', error: 'Код обязателен' }
            ],
            error: null,
            emailInput: [
                { id: 'email', label: 'Почта', placeholder: 'Почта', type: 'email', value: '', error: 'Почта обязателна' }
            ]
        }
    },
    methods: {
        async sendVerificationCode() {
            const { isError, errorMessage } = inputUtils.validateInputs(this.emailInput)

            if (isError) {
                this.error = errorMessage
                return
            }

            var email = null

            if (this.emailInput[0].value !== this.userStore.myUserInfo.email) {
                email = this.emailInput[0].value
            }

            await this.userStore.sendVerificationCode(email)

            if (!this.userStore.error) {
                this.codeSending = true
            } else {
                this.error = this.userStore.error
            }
        },

        async submitVerificationCode() {
            const { isError, errorMessage } = inputUtils.validateInputs(this.codeInput)

            if (isError) {
                this.error = errorMessage
                return
            }

            await this.userStore.submitVerificationCode(inputUtils.getInputById(this.codeInput, 'code').value)

            if (!this.userStore.error) {
                this.$emit('update:modelValue', false)
                this.userStore.fetchMyUserInfo()
            } else {
                this.error = this.userStore.error
            }
        }
    },

    watch: {
        modelValue(val) {
            if (val) {
                if (this.userStore.myUserInfo?.email) {
                    this.emailInput[0].value = this.userStore.myUserInfo.email
                }
            }
        }
    }
}
</script>

<style lang="scss">
.code-input {
    p {
        margin-bottom: 10px;
    }
}

.email-input {
    p {
        margin-bottom: 10px;
    }
}
</style>
